export default class Point{

    constructor(data = {}) {
        this.data = data.data;
    }

}